import { RetentionViewKey } from '../apollo/graphqlSchema';
import isNil from 'lodash/isNil';
import { IRetentionAnalysisData } from '../apollo/responseTypes';
import { UnreachableCaseError } from 'ts-essentials';

export const singleDayAllValue = 'All';

export const RETENTION_BASIC_VIEW_KEYS = [
  RetentionViewKey.Retention,
  RetentionViewKey.RetentionOverTime,
];

export const RETENTION_INTERVAL_VIEW_KEYS = [
  RetentionViewKey.UsageInterval,
  RetentionViewKey.UsageIntervalOverTime,
];

export const getRowHeaderKeys = (
  retentionAnalysisData: IRetentionAnalysisData,
): string[] => {
  const rowSelector = retentionAnalysisData.tableRowSelector;
  if (!isNil(rowSelector)) {
    if (rowSelector.__typename === 'RetentionStandardTableRowSelector') {
      return [
        rowSelector.avgRetention.key,
        ...rowSelector.standardRows.map((r) => r.cohortStart.key),
      ];
    } else if (rowSelector.__typename === 'RetentionOverTimeTableRowSelector') {
      return rowSelector.overTimeRows.map((r) => r.returnPeriod.key);
    } else {
      throw new UnreachableCaseError(rowSelector);
    }
  }
  return [];
};
